import Page from "../Common/Page";
import React from "react";
import { AuthContext } from "../Auth/Auth";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Radio,
  Row,
  Space,
  Spin,
  Form,
  notification,
  Modal,
} from "antd";
import { NavigateFunction } from "react-router-dom";
import {
  ApplyDocumentDrawer,
  ApplyDocumentViewItem,
} from "../Components/ApplyDocumentDrawer";
import {
  SaveScoringDataItem,
  SaveScoringDataRequestBean,
  SCORE_NOTIFICATION_KEY,
  ScoringData,
  StartScoringResponseBean,
  SaveScoringResultResponseBean,
} from "./ScoringPage";
import { ApplyDocumentView } from "../Components/ApplyDocumentView";
import moment from "moment";
import { ScoringTable } from "./ScoringTable";
import { http } from "../Common/http";
import withRouterDom from "../Common/WithReactRouterDom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import modal from "antd/lib/modal";
import ScoringClock from "./ScoringClock";
import { Messages } from "../Common/ValidateMessages";
import { isNullOrSpace } from "../Common/Utils";

const { confirm } = Modal;

interface Props {
  objectId: string;
  useCase: string; // 1:採点担当者採点、2:採点確定、3:スーパー修正、4:閲覧
  scoringType: string; // 1：答案、2：面接
  scoringData: ScoringData;
  backToBeforePage: (needConfirm?: boolean) => void;
  setShowDialog: (showDialog: boolean) => void;
  navigation?: NavigateFunction;
}

class ScoringInterviewPage extends React.Component<Props, any> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props: Props, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
    const limitSeconds =
      this.props.scoringData.elapsedMinute * 60 +
      this.props.scoringData.elapsedSecond;
    let interviewElapsedTime = 0;
    if (this.props.scoringData.applicants[0].userScoringResult) {
      interviewElapsedTime =
        this.props.scoringData.applicants[0].userScoringResult
          .interviewElapsedTime;
    }
    // 欠席データをマップ化
    let afMap = new Map();
    if (this.props.useCase === "1") {
      this.props.scoringData.applicants.forEach((applicant, applicantIndex) => {
        afMap.set(
          applicant.applicantId,
          applicant.userScoringResult?.absenceFlag === "1" ? true : false
        );
      });
    }
    this.state = {
      allocationFixed: this.props.useCase !== "4" ? false : true,
      documentDrawerVisible: false,
      applyDocuments: [],
      interviewSeconds: interviewElapsedTime,
      beginDatetime: Date.now(),
      submitbutton: "",
      limit: limitSeconds,
      afMap: afMap,
    };
  }
  async componentDidMount() {}
  componentWillUnmount() {
    notification.close(SCORE_NOTIFICATION_KEY);
  }

  onShowQestion = (e) => {
    document.getElementById("question_div")!.style.display = "";
    document.getElementById("op_question_div")!.style.display = "none";
    document.getElementById("cl_question_div")!.style.display = "";
  };

  onHideQuestion = (e) => {
    document.getElementById("question_div")!.style.display = "none";
    document.getElementById("op_question_div")!.style.display = "";
    document.getElementById("cl_question_div")!.style.display = "none";
  };

  // onShowStudentDetail = (e) => {
  //   document.getElementById("dl_student_info")!.style.display = "";
  //   document.getElementById("op_student_info")!.style.display = "none";
  //   document.getElementById("cl_student_info")!.style.display = "";
  // };

  // onHideStudentDetail = (e) => {
  //   document.getElementById("dl_student_info")!.style.display = "none";
  //   document.getElementById("op_student_info")!.style.display = "";
  //   document.getElementById("cl_student_info")!.style.display = "none";
  // };

  onDocumentLinkClick = (appliDocuments?: ApplyDocumentViewItem[]) => {
    this.setState({
      documentDrawerVisible: true,
      applyDocuments: appliDocuments,
    });
  };
  onDocumentDrawerClose = () => {
    this.setState({
      applyDocuments: undefined,
      documentDrawerVisible: false,
    });
  };

  // backToBeforePage = () => {
  //   const { navigation } = this.props;
  //   if (this.props.useCase === "1") {
  //     navigation!(`/ScoringList`);
  //   } else if (this.props.useCase === "2") {
  //     navigation!(`/ScoringResultList`);
  //   } else if (this.props.useCase === "3") {
  //     navigation!(`/ScoringResultList`);
  //   }
  // };

  onFinish = async () => {
    // console.log("Success:", Object.keys(values));
    let values;
    try {
      // if (this.props.useCase === "1" && this.state.afChecked) {
      //   values = await this._form.current.getFieldsValue(true);
      // } else {
      // values = await this._form.current.validateFields();
      // }
      if (this.props.useCase === "1" && this.state.submitbutton === "save") {
        values = await this._form.current.getFieldsValue(true);
      } else {
        values = await this._form.current.validateFields();
      }
      // console.log("Success:", values);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
      return;
    }
    const items: SaveScoringDataItem[] = [];
    Object.keys(values).forEach((key, keyIndex) => {
      const value: string = values[key] ? String(values[key]) : "";
      items.push({ key: key, value: value });
    });
    let scoringStatus = "";
    let api = "";
    if (this.props.useCase === "1") {
      scoringStatus = this.state.submitbutton === "complete" ? "2" : "1";
      api = "/Scoring/savedata";
    } else if (this.props.useCase === "2") {
      scoringStatus = "4";
      api = "/Scoring/saveconfirmdata";
    } else if (this.props.useCase === "3") {
      scoringStatus = "3";
      api = "/Scoring/saveupdatedata";
    }
    try {
      this._page.current?.setState({ isPageLoading: true });
      const saveData: SaveScoringDataRequestBean = {
        examinationSubjectId: this.props.scoringData.examinationSubjectId,
        useCase: this.props.useCase,
        scoringPatternType: this.props.scoringData.scoringPatternType,
        interviewElapsedTime: this.state.interviewSeconds,
        scoringStatus: scoringStatus,
        values: items,
      };
      const result = await http<
        SaveScoringResultResponseBean,
        SaveScoringDataRequestBean
      >({
        path: api,
        method: "post",
        body: saveData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        message.success(Messages["MSG-004"]);
        this._page.current?.setState({ isPageLoading: false });
        if (this.state.submitbutton === "complete") {
          this.props.backToBeforePage();
        }
      } else {
        this._page.current?.setState({ isPageLoading: false });
        let errorContent = result.body?.error;
        if (isNullOrSpace(errorContent)) {
          errorContent = Messages["ERR-047"];
        }
        message.error(errorContent);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-047"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  setFormFieldValue = (name: string, value: any) => {
    this._form.current.setFieldsValue({ [name]: value });
  };
  getFormFieldValue = (name: string): any => {
    return this._form.current.getFieldValue(name);
  };
  onCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-008"],
      icon: <ExclamationCircleOutlined />,
      content: Messages["CON-009"],
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onUpdateCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-010"],
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onConfirmCompleteButtonClick = (e) => {
    confirm({
      title: Messages["CON-011"],
      icon: <ExclamationCircleOutlined />,
      content: Messages["CON-012"],
      onOk: () => {
        this.setState({ submitbutton: "complete" }, () => {
          this.onFinish();
        });
        // this._form.current.submit();
      },
      onCancel: () => {
        this.setState({ submitbutton: "" });
      },
    });
  };
  onSaveButtonClick = (e) => {
    this.setState({ submitbutton: "save" }, () => {
      this.onFinish();
    });
    // this._form.current.submit();
  };
  onBeginButtonClick = async () => {
    let api = "";
    if (this.props.useCase === "1") {
      api = "/Scoring/start";
    } else if (this.props.useCase === "2") {
      api = "/Scoring/startconfirm";
    } else if (this.props.useCase === "3") {
      api = "/Scoring/startupdate";
    }
    try {
      const afMap = new Map();
      if (this.props.useCase === "1") {
        let isOk = true;
        this.props.scoringData.applicants.forEach((x) => {
          const af = this._form.current.getFieldValue(`af_${x.applicantId}`);
          // console.log(af);
          if (af === undefined || (af !== "0" && af !== "1")) {
            isOk = false;
            return;
          }
          afMap.set(x.applicantId, af === "1");
        });
        if (!isOk) {
          modal.error({
            title: Messages["ERR-048"],
          });
          return;
        }
        confirm({
          title: Messages["CON-013"],
          icon: <ExclamationCircleOutlined />,
          onOk: () => {
            afMap.forEach((v, k, m) => {
              if (v === true) {
                let sumDiv = document.querySelector(`#sum_${k}`);
                let nodeList = document.querySelectorAll<HTMLInputElement>(
                  `input[id^=score_${k}_]`
                );
                nodeList.forEach((node) => {
                  this.setFormFieldValue(node.id, "");
                });
                sumDiv!.innerHTML = String(0);
              }
            });
            this.doBegin(api, afMap);
          },
          onCancel: () => {
            return;
          },
        });
      } else {
        this.doBegin(api, afMap);
      }
    } catch (error) {
      // errorService.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  doBegin = async (api: string, afMap: Map<any, any>) => {
    this._page.current?.setState({ isPageLoading: true });
    const result = await http<StartScoringResponseBean, any>({
      path: api,
      method: "post",
      accessToken: this.context.accessToken,
      body: {
        examSubjectId: this.props.scoringData.examinationSubjectId,
        objectId: this.props.objectId,
      },
    });
    if (result.ok && result.body) {
      this._page.current?.setState({ isPageLoading: false });
      this.setState({ allocationFixed: true, afMap: afMap });
      this.props.setShowDialog(true);
      if (result.body?.beginDateTime) {
        this.setState({ beginDatetime: result.body?.beginDateTime });
      } else {
        this.setState({ beginDatetime: Date.now() });
      }
    } else {
      this._page.current?.setState({ isPageLoading: false });
      let errorContent = result.body?.error;
      if (isNullOrSpace(errorContent)) {
        errorContent = Messages["ERR-020"];
      }
      modal.error({
        title: Messages["ERR-049"],
        content: errorContent,
      });
    }
  };

  setButtonRow = () => {
    if (this.props.useCase === "1") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) => {
                this.props.backToBeforePage(this.state.allocationFixed);
              }}
              style={{
                fontSize: "15px",
              }}
            >
              担当受験生一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <Space
              style={{ display: this.state.allocationFixed ? "" : "none" }}
            >
              <span>採点日時</span>
              <span>
                {moment(this.props.scoringData.scoringStartDateTime).format(
                  "yyyy/MM/DD HH:mm"
                )}
                <br />
                {moment(this.props.scoringData.scoringEndDateTime).format(
                  "yyyy/MM/DD HH:mm"
                )}
              </span>
              <Space
                style={{
                  visibility:
                    !this.props.scoringData.applicants[0].userScoringResult ||
                    this.props.scoringData.applicants[0].userScoringResult
                      ?.scoringStatus === null ||
                    this.props.scoringData.applicants[0].userScoringResult
                      ?.scoringStatus === "0"
                      ? "visible"
                      : "hidden",
                }}
              >
                <span
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  開始時刻
                </span>
                <span className="digital_clock">
                  {moment(this.state.beginDatetime).format("HH:mm")}
                </span>
                <span style={{ marginLeft: "10px" }}>経過時間</span>
                <ScoringClock
                  className="digital_clock"
                  ticking={
                    this.state.allocationFixed &&
                    (!this.props.scoringData.applicants[0].userScoringResult ||
                      this.props.scoringData.applicants[0].userScoringResult
                        ?.scoringStatus === null ||
                      this.props.scoringData.applicants[0].userScoringResult
                        ?.scoringStatus === "0")
                  }
                  seconds={this.state.interviewSeconds}
                  onChange={() => {
                    const cSeconds = this.state.interviewSeconds;
                    if (cSeconds + 1 === this.state.limit) {
                      const args = {
                        key: SCORE_NOTIFICATION_KEY,
                        message: Messages["MSG-005"],
                        description: Messages["MSG-006"],
                        duration: 0,
                      };
                      notification.warn(args);
                    }
                    this.setState({
                      interviewSeconds: cSeconds + 1,
                    });
                  }}
                />
              </Space>
              <Button
                type="primary"
                danger={true}
                size="middle"
                style={{ marginLeft: "40px" }}
                onClick={(e) => this.onCompleteButtonClick(e)}
              >
                完了
              </Button>
              <Button
                type="primary"
                size="middle"
                onClick={(e) => this.onSaveButtonClick(e)}
              >
                一時保存
              </Button>
            </Space>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "2") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) =>
                this.props.backToBeforePage(this.state.allocationFixed)
              }
              style={{
                fontSize: "15px",
              }}
            >
              採点結果一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <div style={{ float: "right" }}>
              <Space
                style={{
                  display: this.state.allocationFixed ? "" : "none",
                }}
              >
                <Button
                  type="primary"
                  danger={true}
                  size="middle"
                  onClick={(e) => this.onConfirmCompleteButtonClick(e)}
                >
                  採点確定
                </Button>
              </Space>
              <Space
                style={{
                  display: this.state.allocationFixed ? "none" : "",
                }}
              >
                <Popconfirm
                  title={Messages["CON-013"]}
                  onConfirm={(e) => {
                    this.onBeginButtonClick();
                  }}
                  okText="OK"
                  cancelText="キャンセル"
                >
                  <Button type="primary" size="middle">
                    採点確定値入力
                  </Button>
                </Popconfirm>
              </Space>
            </div>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "3") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) =>
                this.props.backToBeforePage(this.state.allocationFixed)
              }
              style={{
                fontSize: "15px",
              }}
            >
              採点結果一覧に戻る
            </Button>
          </Col>
          <Col span={18}>
            <div style={{ float: "right" }}>
              <Space
                style={{
                  display: this.state.allocationFixed ? "" : "none",
                }}
              >
                <Button
                  type="primary"
                  danger={true}
                  size="middle"
                  onClick={(e) => this.onUpdateCompleteButtonClick(e)}
                >
                  保存
                </Button>
              </Space>
              <Space
                style={{
                  display: this.state.allocationFixed ? "none" : "",
                }}
              >
                <Popconfirm
                  title={Messages["CON-014"]}
                  onConfirm={(e) => {
                    this.onBeginButtonClick();
                  }}
                  okText="OK"
                  cancelText="キャンセル"
                >
                  <Button type="primary" size="middle">
                    採点修正開始
                  </Button>
                </Popconfirm>
              </Space>
            </div>
          </Col>
        </Row>
      );
    } else if (this.props.useCase === "4") {
      return (
        <Row className="button-row" align="middle">
          <Col span={6}>
            <Button
              type="link"
              onClick={(e) => this.props.backToBeforePage()}
              style={{
                fontSize: "15px",
              }}
            >
              志願者一覧に戻る
            </Button>
          </Col>
        </Row>
      );
    }
  };

  render(): React.ReactNode {
    const personNodes: any[] = [];
    this.props.scoringData.applicants.forEach((applicant, applicantIndex) => {
      const initialValue = applicant.userScoringResult?.absenceFlag;
      const titleNodes: any[] = [];
      titleNodes.push(
        <Button
          key={`button1_${applicantIndex}`}
          type="primary"
          onClick={() => this.onDocumentLinkClick(applicant.commonDocuments)}
          style={{ marginBottom: "2px" }}
        >
          提出書類
        </Button>
      );
      if (applicant.facePictureDocument) {
        titleNodes.push(
          <div
            style={{ width: "80px", height: "122px" }}
            key={`div1_${applicantIndex}`}
          >
            <ApplyDocumentView viewDocument={applicant.facePictureDocument!} />
          </div>
        );
      }
      if (this.props.scoringData.dispFlag_ExamNumber === "1") {
        titleNodes.push(
          <span
            style={{ fontSize: "17px", textAlign: "center" }}
            key={`span1_${applicantIndex}`}
          >
            {applicant.examNo}
          </span>
        );
      }
      if (this.props.scoringData.dispFlag_Name === "1") {
        titleNodes.push(
          <span
            style={{ fontSize: "17px", textAlign: "center" }}
            key={`span2_${applicantIndex}`}
          >
            {applicant.sei} {applicant.mei}
          </span>
        );
      }
      if (this.props.scoringData.dispFlag_NameKana === "1") {
        titleNodes.push(
          <div
            style={{ fontSize: "17px", textAlign: "center" }}
            key={`span3_${applicantIndex}`}
          >
            {applicant.seiKana} {applicant.meiKana}
          </div>
        );
      }
      if (this.props.scoringData.dispFlag_Birthday === "1") {
        titleNodes.push(
          <span key={`span4_${applicantIndex}`}>
            {moment(applicant.birthday).format("yyyy/MM/DD")}
          </span>
        );
      }
      if (this.props.scoringData.dispFlag_HighSchool === "1") {
        titleNodes.push(
          <div
            key={`span5_${applicantIndex}`}
            style={{ width: "120px", height: "40px", textAlign: "center" }}
          >
            {applicant.highSchoolName}
          </div>
        );
      }

      titleNodes.push(
        <Form.Item
          label=""
          name={`af_${applicant.applicantId}`}
          initialValue={initialValue}
        >
          <Radio.Group
            key={`radio_${applicantIndex}`}
            className="scroe-people-confirm-div"
          >
            <Space direction="vertical" size={0}>
              <Radio value="0">本人確認済</Radio>
              <Radio value="1">欠　　　席</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      );
      personNodes.push(
        <Space
          key={applicantIndex}
          size={0}
          direction="vertical"
          align="center"
          style={{ border: "1px solid black", padding: "5px" }}
        >
          {titleNodes}
        </Space>
      );
    });
    const buttonRow = this.setButtonRow();
    return (
      <Page ref={this._page} title="採点">
        <div className="data_content">
          <Form ref={this._form} onFinish={this.onFinish}>
            {buttonRow}
            <div className="scoring_list_group">
              <div className="scoring_list_header">
                <div style={{ fontWeight: "bold" }}>
                  {this.props.scoringData.judgementUnitName}{" "}
                  {this.props.scoringData.subjectName}
                </div>
                {this.props.scoringData.notes &&
                this.props.scoringData.notes != null ? (
                  <div
                    style={{
                      color: "red",
                      whiteSpace: "pre-wrap",
                      fontSize: "13px",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    {this.props.scoringData.notes}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <Space
                style={{
                  display:
                    this.props.useCase !== "1" ||
                    (this.props.useCase === "1" && this.state.allocationFixed)
                      ? "none"
                      : "",
                  marginTop: "10px",
                }}
                direction="vertical"
              >
                <Space>{personNodes}</Space>
                <Button
                  type="primary"
                  size="middle"
                  onClick={() => this.onBeginButtonClick()}
                >
                  {!this.props.scoringData.applicants[0].userScoringResult ||
                  this.props.scoringData.applicants[0].userScoringResult
                    ?.scoringStatus === null ||
                  this.props.scoringData.applicants[0].userScoringResult
                    ?.scoringStatus === "0"
                    ? "採点開始"
                    : "採点修正"}
                </Button>
              </Space>
            </div>

            <Spin indicator={<></>} spinning={!this.state.allocationFixed}>
              <ScoringTable
                showPersonInfo={
                  this.props.useCase !== "1" ||
                  (this.props.useCase === "1" && this.state.allocationFixed)
                }
                showPersonInfoItemFlags={[
                  this.props.scoringData.dispFlag_ExamNumber,
                  this.props.scoringData.dispFlag_Name,
                  this.props.scoringData.dispFlag_NameKana,
                  this.props.scoringData.dispFlag_Birthday,
                  this.props.scoringData.dispFlag_HighSchool,
                ]}
                pattern={this.props.scoringData.scoringPatternType}
                useCase={this.props.useCase}
                scoringType={this.props.scoringType}
                evaluations={this.props.scoringData.evaluationViewPoints}
                applicants={this.props.scoringData.applicants}
                onDocumentLinkClick={this.onDocumentLinkClick}
                setFormFiledValue={this.setFormFieldValue}
                getFormFiledValue={this.getFormFieldValue}
                afMap={this.state.afMap}
              />
              <br />
            </Spin>
          </Form>
        </div>
        <ApplyDocumentDrawer
          documents={this.state.applyDocuments}
          onClose={this.onDocumentDrawerClose}
          visible={this.state.documentDrawerVisible}
        />
      </Page>
    );
  }
}

export default withRouterDom(ScoringInterviewPage);
